import { apolloClient } from "@/utils/graphql-client";
import {
  Get_SmeetzPicturesQuery,
  Get_SmeetzPicturesQueryVariables,
} from "@/types/gql/generated/graphql";
import { GET_SmeetzPictures } from "./queries/common.graphql";

export async function getSmeetzPictures(entity: number, entityIds: number[]) {
  const res = await apolloClient.query<
    Get_SmeetzPicturesQuery,
    Get_SmeetzPicturesQueryVariables
  >({
    query: GET_SmeetzPictures,
    variables: {
      condition: `(entity,eq,${entity})~and(entity_id,in,${entityIds.join(
        ","
      )})`,
    },
  });

  const pictures = res.data.SmeetzPicture || [];
  return pictures;
}
